import googleLogo from '@lumapps/assets/brands/google.svg';
import lumappsLogo from '@lumapps/assets/brands/lumapps.svg';
import microsoftLogo from '@lumapps/assets/brands/microsoft.svg';
import oktaLogo from '@lumapps/assets/brands/okta.svg';
import { IDENTITY_PROVIDER_TYPES } from '@lumapps/providers/constants';

import { LoginProviderButtonProps } from './types';

export const LOGIN_METHODS = {
    EMAIL: 'EMAIL',
    GOOGLE: 'GOOGLE',
    MICROSOFT: 'MICROSOFT',
    OKTA: 'OKTA',
    SAML: 'SAML',
    OTP: 'OTP', // magic_link
};

/**
 * How long a sign-in link sent by email stays valid, in minutes.
 * Mirrors the validity of the one-time codes generated by the backend (600 seconds).
 */
export const SIGN_IN_LINK_VALIDITY_IN_MINUTES = 10;

export const LOGIN_PROVIDER_CONFIGURATION: Record<any, Partial<LoginProviderButtonProps>> = {
    [IDENTITY_PROVIDER_TYPES.OKTA]: {
        leftImage: oktaLogo,
        loginMethod: LOGIN_METHODS.OKTA,
    },
    [IDENTITY_PROVIDER_TYPES.GOOGLE]: {
        leftImage: googleLogo,
        loginMethod: LOGIN_METHODS.GOOGLE,
    },
    [IDENTITY_PROVIDER_TYPES.MICROSOFT]: {
        leftImage: microsoftLogo,
        loginMethod: LOGIN_METHODS.MICROSOFT,
    },
    [IDENTITY_PROVIDER_TYPES.EMAIL]: {
        leftImage: lumappsLogo,
        loginMethod: LOGIN_METHODS.EMAIL,
    },
    [IDENTITY_PROVIDER_TYPES.SAML]: {
        leftImage: lumappsLogo,
        loginMethod: LOGIN_METHODS.SAML,
    },
    [IDENTITY_PROVIDER_TYPES.SAML_V2]: {
        leftImage: lumappsLogo,
        loginMethod: LOGIN_METHODS.SAML,
    },
    [IDENTITY_PROVIDER_TYPES.OTP]: {
        leftImage: lumappsLogo,
        loginMethod: LOGIN_METHODS.OTP,
    },
};
